import { css } from "styled-components";
import token from "styled-token";
import { mediaBreakpointMixin } from "../mediaBreakpointMixin";
import { spacingMixin } from "../spacingMixin";
import { CARD_TYPES } from "../../constants/CARD";

var interactiveCSS = function interactiveCSS(props) {
  if (typeof props.interactive === "undefined") {
    return token({
      backgroundColor: "Card.backgroundColor"
    }, function (_ref) {
      var backgroundColor = _ref.backgroundColor;
      return css(["background-color:", ";"], backgroundColor);
    })(props);
  }

  return token({
    backgroundColor: "Card.backgroundColor",
    hoverBackgroundColor: "colors.blue100",
    pressedBorderColor: "Card.borderColorPrimary"
  }, function (_ref2) {
    var backgroundColor = _ref2.backgroundColor,
        hoverBackgroundColor = _ref2.hoverBackgroundColor,
        pressedBorderColor = _ref2.pressedBorderColor;
    return css(["background-color:", ";cursor:pointer;outline:none;position:relative;transition-property:background-color,box-shadow;transition-duration:0.2s;transition-timing-function:ease;&:hover,&:active{background-color:", ";}&:after{border:2px solid ", ";content:\"\";display:none;pointer-events:none;position:absolute;speak:none;z-index:1;}&[aria-pressed=\"true\"]:after{display:block;}"], backgroundColor, hoverBackgroundColor, pressedBorderColor);
  })(props);
};

var borderCSS = function borderCSS(props) {
  if (props.appearance === "borderless") {
    return token({
      borderColor: "Card.borderColor"
    }, function (_ref3) {
      var borderColor = _ref3.borderColor;
      return css(["border:0 solid ", ";&[aria-pressed=\"true\"]{border-color:transparent;}&:after{bottom:0;left:0;right:0;top:0;}"], borderColor);
    })(props);
  }

  return token({
    borderColor: "Card.borderColor"
  }, function (_ref4) {
    var borderColor = _ref4.borderColor;
    return css(["border:1px solid ", ";&[aria-pressed=\"true\"]{border-color:transparent;}&:after{bottom:-1px;left:-1px;right:-1px;top:-1px;}"], borderColor);
  })(props);
};

var primaryCSS = function primaryCSS(props) {
  var cardType = props.cardType,
      cardDirection = props.cardDirection;

  if (cardType !== CARD_TYPES.primary) {
    return "";
  }

  return token("Card.borderColorPrimary", function (borderColor) {
    return css(["border-", ":3px solid ", ";&[aria-pressed='true']{border-", ":3px solid ", ";}&:after{", ":-3px;}"], cardDirection, borderColor || "", cardDirection, borderColor || "", cardDirection);
  })(props);
};

var boxShadowCSS = function boxShadowCSS(props) {
  if (typeof props.interactive === "undefined" && !props.cardElevation) {
    return "";
  }

  if (typeof props.interactive === "undefined" && props.cardElevation) {
    return token("shadows.shadow100", function (boxShadow) {
      return "box-shadow: " + (boxShadow || "") + ";";
    })(props);
  }

  if (typeof props.interactive !== "undefined" && !props.cardElevation) {
    return token({
      focusShadow: "shadows.focus"
    }, function (_ref5) {
      var focusShadow = _ref5.focusShadow;
      return css(["&:focus{box-shadow:", ";}"], focusShadow);
    })(props);
  }

  return token({
    elevationShadow: "shadows.shadow100",
    hoverElevationShadow: "shadows.shadow200",
    focusShadow: "shadows.focus"
  }, function (_ref6) {
    var elevationShadow = _ref6.elevationShadow,
        hoverElevationShadow = _ref6.hoverElevationShadow,
        focusShadow = _ref6.focusShadow;
    return css(["box-shadow:", ";&:hover{box-shadow:", ";}&:active{box-shadow:none;}&:focus{box-shadow:", ";}&:focus:hover{box-shadow:", ";}&:focus:active{box-shadow:", ";}&[aria-pressed=\"true\"],[aria-pressed=\"true\"]:hover,[aria-pressed=\"true\"]:active{box-shadow:none;}&[aria-pressed=\"true\"]:focus,[aria-pressed=\"true\"]:focus:hover,[aria-pressed=\"true\"]:focus:active{box-shadow:", ";}"], elevationShadow, hoverElevationShadow, elevationShadow + ", " + focusShadow, hoverElevationShadow + ", " + focusShadow, focusShadow, focusShadow);
  })(props);
};
/** @class CardMixin */

/** @method */


export var CardMixin = function CardMixin(props) {
  return token({
    borderRadius: "radii.md"
  }, function (_ref7) {
    var borderRadius = _ref7.borderRadius;
    return css(["@media ", "{border-radius:", "px;&:after{border-radius:", "px;}}", " ", " ", " ", " ", ""], mediaBreakpointMixin("md")(props), borderRadius || "", borderRadius || "", spacingMixin(Object.assign({
      padding: "sm"
    }, props)), interactiveCSS(props), borderCSS(props), primaryCSS(props), boxShadowCSS(props));
  })(props);
};